import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import apiClient from "../../shared/api/apiClient";

// ------------------------PRODUCT-----------------------------------------

export const getCheckout = (field?: object) => {
  // console.log("Checkout SAGA", field);
};

export interface CheckoutParams {
  tenantId: string;
  tier: string;
  subscription: string;
  productId: string;
  quantity: number;
  domain: string;
  subscriptionId?: string;
  type?: string;
}
export const postCreateProductSubscription = (body: CheckoutParams) => {
  // const URL = `http://localhost:8080/custom-subscription?sessionId=${productId}`;
  // const URL = `http://localhost:8080/get-tenant?tenantId=${body.TenantId}`;
  // const URL = `http://localhost:8080/update-tenant?tenantId=${body.TenantId}`;
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/productCheckout/?create_subscription_id=${body.productId}`;

  body.subscriptionId = body?.productId ?? "";

  // const URL = `http://localhost:8081/?create_subscription_id=${body.productId}`;

  body.type = "create"
  return apiClient
    .post(URL, body)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const postCancelProductSubscription = (body: CheckoutParams) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/productCheckout/?delete_subscription_id=${body.subscriptionId}`;
  // const URL = `http://localhost:8081/?delete_subscription_id=${body.subscriptionId}`;

  const data = {
    ...body,
    type: "delete",
    subscriptionId: body.subscriptionId
  };
  // delete data.subscriptionId;

  return apiClient
    .post(URL, data)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const getRefreshedToken = (body: string) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/refreshSessionToken`;

  const data = {
    tenantDocId: body
  };

  return apiClient
    .post(URL, data)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};
